/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerPatchTransferMutationRequest, TransfersControllerPatchTransferMutationResponse, TransfersControllerPatchTransferPathParams, TransfersControllerPatchTransfer400, TransfersControllerPatchTransfer401, TransfersControllerPatchTransfer403, TransfersControllerPatchTransfer404 } from "../../models/transfersController/TransfersControllerPatchTransfer";

function getTransfersControllerPatchTransferUrl(id: TransfersControllerPatchTransferPathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/transfers/${id}` as const }  
  return res
}

/**
 * @summary Perform an action on a transfer run
 * {@link /api/v1/transfers/:id}
 */
export async function transfersControllerPatchTransfer(id: TransfersControllerPatchTransferPathParams["id"], data?: TransfersControllerPatchTransferMutationRequest, config: Partial<RequestConfig<TransfersControllerPatchTransferMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransfersControllerPatchTransferMutationResponse, ResponseErrorConfig<TransfersControllerPatchTransfer400 | TransfersControllerPatchTransfer401 | TransfersControllerPatchTransfer403 | TransfersControllerPatchTransfer404>, TransfersControllerPatchTransferMutationRequest>({ method : "PATCH", url : getTransfersControllerPatchTransferUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}